import styled, { keyframes } from 'styled-components';
import palette from '../../utilities/palette';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';


export const rotateAnimation = keyframes`
  0% {
    transform: rotate(0turn);
  }
  100% {
    transform: rotate(1turn);
  }
`;


export const StyledConfirmButton = styled.button.attrs<
{
  confirmType: string,
  [key: string]: any
}>(props => ({ type: 'button' }))` &&& {
      font-size: 16px;
      color: white;
      background-color: ${props => props.confirmType === 'yes' ? palette.main : palette.removeBtn.main};
      width: 100px;
      height: 40px;
      cursor: pointer;
      border-radius: 3px;
      box-shadow: 0 8px 5px -5px rgba(0, 0, 0, 0.2);
      display: grid;
      place-content: center;
      transition: 0.2s;

      &:hover {
        background-color: ${props => props.confirmType === 'yes' ? palette.hover : palette.removeBtn.hover};
      }
    }
`;

export const StyledSubmitButton = styled.button.attrs<
  {
    isFailedSubmit?: boolean,
    isDisabled?: boolean
  }
>(props => ({ type: 'submit', disabled: props.isDisabled }))`
  font-size: 22px;
  color: ${(props) => (props.isFailedSubmit ? '#fff' : palette.primary.text)};
  background-color: ${(props) => (props.isFailedSubmit ? palette.stepper.error : palette.main)};
  width: 250px;
  height: 60px;
  cursor: pointer;
  border-radius: 3px;
  box-shadow: 0 8px 5px -5px rgba(0, 0, 0, 0.2);
  display: grid;
  place-content: center;
  transition: 0.2s;

  &:hover {
    background-color: ${ palette.hover };
  }
  &:disabled {
      background-color: ${(props) => (props.isFailedSubmit ? palette.stepper.error : palette.main)};
      cursor: not-allowed;
    }
`;

export const StyledValidateButton = styled.button.attrs(props => ({ type: 'button' }))`
  font-size: 22px;
  color: ${palette.primary.text};
  background-color: ${palette.main};
  align-self: center;
  width: 250px;
  height: 60px;
  cursor: pointer;
  border-radius: 3px;
  box-shadow: 0 8px 5px -5px rgba(0, 0, 0, 0.2);
  display: grid;
  place-content: center;
  transition: 0.2s;

  &:hover {
    background-color: ${palette.hover};
    box-shadow: 0 10px 10px -10px rgb(0 0 0 / 93%);
  }
  &:disabled {
      background-color: ${palette.disabled.background};
      color: ${palette.disabled.text};
    }
`;

export const StyledPrefillButton = styled.button.attrs<
{
  isFailedSubmit?: boolean
}
>(props => ({ type: 'submit' }))`
  font-size: 18px;
  color: white;
  background-color: ${(props) => (props.isFailedSubmit ? palette.removeBtn.main : palette.primary.main)};
  width: 150px;
  height: 40px;
  cursor: pointer;
  border-radius: 3px;
  box-shadow: 0 8px 5px -5px rgba(0, 0, 0, 0.2);
  display: grid;
  place-content: center;
  transition: 0.3s;
  margin-top: 20px;
  margin-bottom: 5px;

  &:hover {
    background-color: ${ palette.primary.hover };
  }
  &:disabled {
      background-color: ${(props) => (props.isFailedSubmit ? palette.removeBtn.main : palette.disabled.background)};
      color: ${(props) => (props.isFailedSubmit ? '#fff' : palette.disabled.text)};
      cursor: not-allowed;
    }
`;

export const StyledPrefillExpander = styled.button.attrs(props => ({ type: 'button',  }))`
  font-size: 18px;
  color: ${palette.primary.text};
  background-color: ${palette.primary.main};
  width: auto;
  height: 40px;
  cursor: pointer;
  border-radius: 3px;
  box-shadow: 0 8px 5px -5px rgba(0, 0, 0, 0.2);
  display: grid;
  place-content: center;
  transition: 0.3s;

  &:hover {
    background-color: ${ palette.primary.hover };
  }
`;

export const AddButton = styled.button.attrs({ type: "button" })` &&& {
  background-color: ${palette.primary.main};
  color: ${palette.primary.text};
  padding: 10px 20px;
  cursor: pointer;
  border: none;
  transition: 0.5s all ease-out;
  border-radius: 5px;
  margin: 10px 0;
  width: 250px;
  align-self: flex-end;

  &:hover {
    box-shadow: 0 10px 10px -10px rgb(0 0 0 / 93%);
  }

  &:disabled {
    background-color: ${ palette.disabled.background };
    color: ${ palette.disabled.text };
    cursor: not-allowed;
  }
    
}
`;

  export const Button = styled.button.attrs<
  {
    variant?: string
  }>({ type: "button" })`
    background-color: ${(props) =>
      props.variant === "outline"
        ? palette.primary.main
        : palette.primary.hover};
    color: ${palette.primary.text};
    padding: 10px 20px;
    cursor: pointer;
    border: none;
    transition: 0.5s all ease-out;
    border-radius: 5px;
    margin: 10px 0;
    width: 250px;
    align-self: flex-end;
    
    &:hover {
      background-color: ${(props) =>
        props.variant !== "outline"
          ? palette.primary.main
          : palette.primary.hover};
    }
  `;

export const StyledPreviewButton = styled.button.attrs(props => ({ type: 'button' }))`
  font-size: 22px;
  color: ${palette.primary.text};
  background-color: ${palette.primary.main};
  width: auto;
  height: auto;
  cursor: pointer;
  border-radius: 3px;
  box-shadow: 0 8px 5px -5px rgba(0, 0, 0, 0.2);
  display: grid;
  place-content: center;
  transition: 0.2s;

  &:hover {
    background-color: ${palette.primary.hover};
  }
`;



export const SubmitButton = styled(Button).attrs({ type: 'submit', })`
  
    background-color: ${(props) => (props.variant === "outline" ? palette.primary.main : '#4c7aaf')};
    color: ${(props) => (props.variant === "outline" ? '#4c7aaf' : palette.primary.main)};
    box-shadow: 0 5px #666;
    transform: translateY(4px);
  
    &:hover {
        background-color: ${(props) => (props.variant !== "outline" ? palette.primary.main : '#4c7aaf')};
        color: ${(props) => (props.variant !== "outline" ? '#4c7aaf' : palette.primary.main)};
    }
`;  

export const RemoveButtonAccordion = styled.div<{
  disabled?: boolean;
}>` &&& {
    background-color: ${props => props.disabled ? palette.disabled.background : palette.removeBtn.main};
    color: ${props => props.disabled ? palette.disabled.text : palette.removeBtn.text};
    padding: 10px 15px;
    border: none;
    border-radius: 5px;
    width: auto;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    transition: 0.5s all ease-out;
    float: right;
    margin-right: 0px;
    margin-left: auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    user-select: none;

    &:hover {
      background-color: ${props => props.disabled ? palette.disabled.background : palette.removeBtn.hover};
    }
  }
`;
export const RemoveErrorButton = styled(Button).attrs({ type: 'button', })`
  background-color: ${(props) => (props.variant === "outline" ? palette.removeBtn.main : palette.removeBtn.hover)};
  color: ${palette.removeBtn.text};
  border: none;
  border-radius: 5px;
  width: auto;
  padding: 5px 10px; // adjust padding as needed
  font-size: 14px; // adjust font size as needed
  cursor: pointer;
  transition: 0.5s all ease-out;
  float: right;

  &:hover {
    background-color: ${palette.removeBtn.main};
  }
  &:disabled {
    background-color: ${ palette.disabled.background };
    color: ${ palette.disabled.text };
    cursor: not-allowed;
  }
`;

export const RemoveButton = styled.button.attrs({ type: 'button'})` &&& {
  background-color: ${palette.stepper.error};
  color: ${palette.removeBtn.text};
  padding: 10px 15px;
  margin: 0px;
  border: none;
  border-radius: 5px;
  width: auto;
  transition: 0.5s all ease-out;
  float: right;

  &:disabled {
    background-color: ${ palette.disabled.background };
    color: ${ palette.disabled.text };
    cursor: not-allowed;
  }

  &:not(:disabled) {
    cursor: pointer;
  }

  &:not(:disabled):hover {
    background-color: ${palette.removeBtn.hover};
    color: ${palette.removeBtn.text};
  }

  &:not(:disabled):active {
    transform: scale(0.95);
    transition: 0.2s all ease-out; 
  }
}
`;


export const PrepopulateButton = styled.button.attrs<
  {
    variant?: string
  }
>({ type: "button" })` &&&
  {
    background-color: ${(props) =>
      props.variant === "outline" ? palette.primary.main : palette.primary.hover};
    color: ${palette.primary.text};
    padding: 10px 10px;
    cursor: pointer;
    border: none;
    transition: 0.5s all ease-out;
    border-radius: 5px;

    &:hover {
      background-color: ${(props) =>
        props.variant !== "outline"
          ? palette.primary.main
          : palette.primary.hover};
    }
    &:disabled {
      background-color: ${ palette.disabled.background };
      color: ${ palette.disabled.text };
      cursor: not-allowed;
    }
  }
`;

export const NextButtonIcon = styled(ArrowForwardIcon)`
  margin-left: 8px;
  font-size: 1.2em;
`;

export const NextButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background-color: ${palette.main};
  color: ${palette.body};
  font-size: 18px;
  font-weight: 500;
  padding: 10px 24px;
  border-radius: 5px;
  transition: background 0.2s;
  &:hover {
    background-color: ${palette.primary.hover};
  }
  &:disabled {
    background-color: ${palette.disabled.background};
    color: ${palette.disabled.text};
    cursor: not-allowed;
  }
`;